import React from 'react'
import { t } from 'ttag'
import { Box } from 'components/layout/Box/Box'
import { BellCurve } from 'components/shared/BellCurve/BellCurve'
import { Stats } from 'components/shared/Stats/Stats'
import tabStyles from '../tabs.module.scss'
import styles from './ProcessingSpeed.module.scss'
import { useGMAState } from './hooks'
import cx from 'classnames'
import { CandidateSelect } from '../../common/CandidateSelect/CandidateSelect'
import { CautionSign } from 'components/shared/CautionSign/CautionSign'
import { GMA_FACTOR, hasCaution } from '../cautions'

type ProcessingSpeedProps = {
  factor: string
  language?: string
  response: any[]
  isCandidate?: boolean
  isGreyBackground?: boolean
  name?: string
  candidates: any[]
  selectedCandidates?: any
  setSelectedCandidates?: (candidates: any) => void
  cautions?: any[]
}

export const ProcessingSpeed = ({
  factor,
  language,
  response,
  isCandidate = false,
  isGreyBackground = false,
  name,
  candidates,
  selectedCandidates,
  setSelectedCandidates,
  cautions = [],
}: ProcessingSpeedProps) => {
  const {
    state: { translations, single, descriptions, scores, allScores, disabled },
  } = useGMAState({
    factor,
    language,
    response,
    candidates,
    isCandidate,
    selectedCandidates,
    setSelectedCandidates,
  })

  return (
    <Box
      className={cx(styles.processingSpeed, {
        [styles.noPadding]: isCandidate,
      })}
    >
      <div className={styles.leftSection}>
        {!isCandidate ? (
          <>
            {' '}
            <div className={styles.titleRow}>
              <div className={tabStyles.tabTitle}>
                {single
                  ? t`General mental ability: ${name}`
                  : t`General mental ability`}
              </div>
              {hasCaution(cautions, GMA_FACTOR) ? (
                <CautionSign placement="bottom" />
              ) : null}
            </div>
            <div
              className={tabStyles.sectionExplanations}
            >{t`Ability to learn, understand instructions, and solve problems`}</div>
            <br />
            <br />{' '}
          </>
        ) : null}

        {single ? null : (
          <CandidateSelect
            {...{
              candidates,
              selectedCandidates,
              setSelectedCandidates,
              disabled,
            }}
          />
        )}

        {translations[0].translation.abstract.map((par, index) => (
          <div key={index}>
            <div key={index} className={tabStyles.paragraph}>
              {par}
            </div>
            {[3, 0].includes(index) ? <br /> : null}
          </div>
        ))}
        <br />
        {!single ? null : (
          <div className={cx(tabStyles.paragraph, tabStyles.bold)}>
            <span>{descriptions[0]}</span>
            <span className={styles.highlight}>
              {translations[0].translation.judgement[0]}
            </span>
            <span>{descriptions[1]}</span>
          </div>
        )}
      </div>
      <div className={styles.rightSection}>
        <Stats
          scores={scores}
          candidates={candidates}
          isGreyBackground={isGreyBackground}
          single={single}
        />
        {!isCandidate && (
          <BellCurve
            allScores={allScores}
            candidates={candidates}
            selectedCandidates={selectedCandidates}
            single={single}
            high
          />
        )}
      </div>
    </Box>
  )
}
